import FJLocalStore from '../../../store/FJLocalStore';
import styles from './FJMediaSetting.module.less';
import PropTypes from 'prop-types';
import FJHoverBoardGradation from '../../../common/components/FJHoverBoard/FJHoverBoardGradation';
import classNames from 'classnames';
import {
    MEDIA_SOURCE_LIST,
    TEXT_TO_VIDEO_RATIO_LIST,
    // STOCK_TYPE_LIST,
} from '../../../config/dataConfig/FJTextToVideoDataConfig';
import FJDropList from '../../../components/FJDropList/FJDropList';
import FJConfig from '../../../config/FJConfig';
import FJSwipe from '../../../common/components/FJSwipe/FJSwipe';
import FJConstant from '../../../constants/FJConstant';
import cionNew from '../../../assets/base64/cion-new.js';

const FJMediaSetting = props => {
    const {
        textToImageStyle,
        textToImageStyleList,
        onChangeStyle,
        ratio,
        mediaSource,
        onChangeRatio,
        onChangeMediaSource,
        isOnlyShowRatio,
        isShowCreditIcon,
        // stockType,
        // onChangeStockType,
    } = props;
    const _renderMediaSource = () => {
        if (!isOnlyShowRatio) return null;
        return (
            <>
                <div className={styles.content_title}>{FJLocalStore._('generation-mode')}</div>

                <div className={styles.button_container}>
                    {MEDIA_SOURCE_LIST.map((item, index) => (
                        <FJHoverBoardGradation
                            key={item.value}
                            className={classNames(styles.source_btn)}
                            active={mediaSource === item.value}
                            onClick={() => onChangeMediaSource(item.value)}
                            contentClassName={classNames(styles.source_btn_content)}
                        >
                            {isShowCreditIcon && index === 0 ? <img className={styles.cion} src={cionNew} /> : null}

                            {FJLocalStore._(item.name)}
                        </FJHoverBoardGradation>
                    ))}
                </div>
            </>
        );
    };
    const _renderTextToImageStyleList = () => {
        if (!isOnlyShowRatio) return null;

        return (
            <>
                <div className={styles.content_title}>{FJLocalStore._('media-source')}</div>

                <FJSwipe itemWidth={110} space={12} className={styles.style_container} needUpdate={true}>
                    {textToImageStyleList.map(item => (
                        <FJHoverBoardGradation
                            key={item.value}
                            className={classNames(styles.category_list_item, {
                                [styles.none_style_box]: item.value === '',
                            })}
                            contentClassName={classNames(item.value === '' ? styles.category_list_item_content : '')}
                            isShowInBorder={item.value !== ''}
                            active={item.name === textToImageStyle.name}
                            onClick={() => onChangeStyle(item)}
                        >
                            <img src={FJConfig.textToImageStylePreviewPath + item.previewImg} />
                            <div className={styles.category_list_item_name_box}>
                                <span className={styles.category_list_item_name}>{FJLocalStore._(item.name)}</span>
                            </div>
                        </FJHoverBoardGradation>
                    ))}
                </FJSwipe>
            </>
        );
    };
    const _renderStockType = () => {
        return null;
        // ljh: 暂时删除
        // return (
        //     <>
        //         <div className={styles.content_title}>{FJLocalStore._('stock-type')}</div>
        //         <FJDropList value={stockType} onChange={onChangeStockType} list={STOCK_TYPE_LIST} />
        //     </>
        // );
    };
    const _renderRatio = () => {
        return (
            <>
                {isOnlyShowRatio && <div className={styles.content_title}>{FJLocalStore._('ratio')}</div>}
                <FJDropList
                    value={ratio}
                    onChange={onChangeRatio}
                    list={TEXT_TO_VIDEO_RATIO_LIST}
                    showCheckIcon={true}
                    overlayWidth={658}
                />
            </>
        );
    };
    const title = isOnlyShowRatio ? FJLocalStore._('media-settings') : FJLocalStore._('ratio');

    return (
        <div className={styles.container}>
            <div className={classNames(styles.title, !isOnlyShowRatio && styles.margin_bottom_8)}>{title}</div>
            {_renderMediaSource()}
            {mediaSource === FJConstant.AI_GENERATED ? _renderTextToImageStyleList() : _renderStockType()}
            {_renderRatio()}
        </div>
    );
};

FJMediaSetting.propTypes = {
    textToImageStyle: PropTypes.object,
    textToImageStyleList: PropTypes.array,
    onChangeStyle: PropTypes.func,
    ratio: PropTypes.object,
    mediaSource: PropTypes.string,
    onChangeRatio: PropTypes.func,
    onChangeMediaSource: PropTypes.func,
    isOnlyShowRatio: PropTypes.bool,
    isShowCreditIcon: PropTypes.bool,
};

export default FJMediaSetting;
